import { JsonObject } from '../helpers';
import {
  CreateUserSettingsModel,
  UserSettingsModel,
} from '../models/user-settings/user-settings.model';
import { UpdateResponse } from '.';
import { get, update } from './sp-api.service';

export const getUserSettings = async (): Promise<UserSettingsModel> => {
  const response = await get('/user/profile?namespace=admin').catch((err) => {
    console.error(err);
  });

  if (!response) {
    return new UserSettingsModel();
  }

  return new UserSettingsModel(response as JsonObject);
};

export const updateUserSettings = async (settings: UserSettingsModel): Promise<UpdateResponse> => {
  const createModel = new CreateUserSettingsModel(settings);
  return update('/user/profile?namespace=admin', createModel._props);
};
